import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';

import App from './App.vue';
import './filters';
import './plugins/api';
import './plugins/auth';
import { i18n } from './plugins/i18n';
import './plugins/vee-validate';
import './plugins/vuetify';
import router from './router';
import store from './store';
import './styles/fonts.css';

Vue.config.productionTip = process.env.NODE_ENV === 'development';

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
